import PageWrapper from 'components/utils/PageWrapper';
import { ReportDashboard } from 'pages/ReportDashboard';
import { ReportPage } from 'components/reporting/ReportPage';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';

export const reportRoutes = {
    path: '/reports',
    element: (
        <PageWrapper titleId="common_reports">
            <ReportDashboard />
        </PageWrapper>
    ),
    children: [
        {
            index: true,
            element: <WrapperEmptyState item={'item'} page="side" noun="reports" />,
        },
        {
            path: ':id',
            element: <ReportPage />,
        },
    ],
};
